import { useNavigate } from "@tanstack/react-router";

import { HotelName } from "../hotels/HotelName";
import { HotelStars } from "../hotels/HotelStars";
import type { FindHotelsOutputData } from "@/app/lib/types/codegen";
import { HotelImages } from "./HotelImages";
import { HotelFacilities } from "./HotelFacilities";
import { HotelContactDetails } from "./HotelContactDetails";
import { ExpandableSection } from "../ExpandableSection";

interface HotelOverviewProps {
  hotel: FindHotelsOutputData;
}

export const HotelOverview = ({ hotel }: HotelOverviewProps) => {
  const navigate = useNavigate();

  return (
    <div className="section-card">
      <div className="flex w-full text-lg font-semibold text-text-primary">
        <HotelName name={hotel.name} />
      </div>
      <div className="mb-3 flex items-center">
        {!!hotel.stars && <HotelStars stars={hotel.stars} />}
      </div>
      <HotelImages
        hotel={hotel}
        onImageClick={() => {
          navigate({
            to: "/hotels/$id/details/images",
            params: { id: hotel.id },
          });
        }}
      />
      <ExpandableSection>
        <div className="text-sm text-text-primary">
          {hotel?.descriptions?.full || hotel?.descriptions?.short}
        </div>
      </ExpandableSection>

      <HotelFacilities hotel={hotel} />
      <HotelContactDetails hotel={hotel} />
    </div>
  );
};
